import {Component} from 'lowkey-component'
import Swiper, {Mousewheel, Pagination} from 'swiper'


export class InterviewList extends Component {

  private swiper: Swiper | null = null

  didMount() {
    this.swiper = new Swiper(this.element, {
      modules: [Pagination, Mousewheel],
      slidesPerView: 'auto',
      spaceBetween: 30,
      preventInteractionOnTransition: true,
      mousewheel: {
        forceToAxis: true,
      },
      pagination: {
        el: '.swiper-progressbar',
        type: 'progressbar',
      },
    })
  }

  didUnmount() {
    this.swiper?.destroy()
  }
}
